import { render, staticRenderFns } from "./movebooks.vue?vue&type=template&id=aa1698e2&scoped=true&"
import script from "./movebooks.vue?vue&type=script&lang=js&"
export * from "./movebooks.vue?vue&type=script&lang=js&"
import style0 from "./movebooks.vue?vue&type=style&index=0&id=aa1698e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1698e2",
  null
  
)

export default component.exports